import React from "react";
import { Chip, ChipProps } from "@mui/material";

type PartnerStatus = "active" | "pending" | "inactive";
type CommissionStatus = "pending" | "approved" | "rejected";
type BookingStatus = "confirmed" | "pending" | "cancelled";

const partnerStatusConfig: Record<
  PartnerStatus,
  { label: string; color: ChipProps["color"] }
> = {
  active: { label: "Active", color: "success" },
  pending: { label: "Pending", color: "warning" },
  inactive: { label: "Inactive", color: "default" },
};

const commissionStatusConfig: Record<
  CommissionStatus,
  { label: string; color: ChipProps["color"] }
> = {
  approved: { label: "Approved", color: "success" },
  pending: { label: "Pending", color: "warning" },
  rejected: { label: "Rejected", color: "error" },
};

const bookingStatusConfig: Record<
  BookingStatus,
  { label: string; color: ChipProps["color"] }
> = {
  confirmed: { label: "Confirmed", color: "success" },
  pending: { label: "Pending", color: "warning" },
  cancelled: { label: "Cancelled", color: "error" },
};

interface StatusChipProps {
  type: "partner" | "commission" | "booking";
  status: string;
  size?: ChipProps["size"];
}

export const StatusChip: React.FC<StatusChipProps> = ({
  type,
  status,
  size = "small",
}) => {
  let config: { label: string; color: ChipProps["color"] };

  if (type === "partner") {
    config = partnerStatusConfig[status as PartnerStatus] ?? {
      label: status,
      color: "default",
    };
  } else if (type === "commission") {
    config = commissionStatusConfig[status as CommissionStatus] ?? {
      label: status,
      color: "default",
    };
  } else {
    config = bookingStatusConfig[status as BookingStatus] ?? {
      label: status,
      color: "default",
    };
  }

  return (
    <Chip
      label={config.label}
      color={config.color}
      size={size}
      sx={{ fontWeight: 500, fontSize: "0.72rem", borderRadius: "6px" }}
    />
  );
};
